// extracted by mini-css-extract-plugin
export var createdDate = "_lo-1";
export var divider = "_lo-2";
export var headerDivider = "_lo-3";
export var messagesCard = "_lo-0";
export var messagesContainer = "_lo-7";
export var messagesContainerWrapper = "_lo-4";
export var pointerCapturingButtonBoxes = "_lo-a";
export var showLeftPanelButton = "_lo-9";
export var showMoreButton = "_lo-c";
export var showMoreButtonContainer = "_lo-b";
export var summaryTitle = "_lo-6";
export var systemMessageCardWrapper = "_lo-d";
export var topButtons = "_lo-8";
export var withPadding = "_lo-5";